import { observable, action, useStrict } from 'mobx';
import { notification } from '@ali/aps-dev';
import ajax from './ajax';
import bannerTopStore from './bannerTopStore';

useStrict(true);
const url = 'https://domainapi.aliyun.com/onsale/search';
class ResultList {
  @observable resultList // 列表
  @observable requestOpts // 筛选参数
  @observable currentPage // 当前页码
  @observable totalPage // 总页数 
  @observable pageSize // 每页展示的数量
  @observable canRegested // 是否可以注册，true表示显示可以注册的域名
  @observable isLoading // 是否加载
  @observable isOver // 是否到底

  constructor() {
    this.resultList = [];
    this.currentPage = 1;
    this.totalPage = 0;
    this.pageSize = 10;
    this.canRegested = false;
    this.isLoading = true;
    this.isOver = false;
    this.listCache = [];
    this.pageSizeCache = this.pageSize;
    this.requestOpts = {
      'allowRegistered': bannerTopStore.allowRegistered,
      'keyWord': bannerTopStore.keyword,
      'constitute': bannerTopStore.constitute,
      'maxLength': bannerTopStore.maxLength,
      'minLength': bannerTopStore.minLength,
      'pageSize': this.pageSize,
      'currentPage': this.currentPage,
      'fetchSearchTotal': true,
      'productType': 7,
      'suffix': bannerTopStore.suffix,
      'sortType': bannerTopStore.sortType,
      'sortBy': bannerTopStore.sortBy,
      'token': 'check-web-hichina-com:' + window.umidToken
    };
  }

  // 获取查询列表
  @action
  async fetchresultList(opts) {
    let options = this.changeRequestOpts(opts);
    this.isOver = false;
    if (!options.suffix && !options.keyWord) {
      this.handlerHideLoading();
      this.setData([]);
      return;
    }
    let result = await ajax({
      type: 'get',
      url: url,
      dataType: 'jsonp',
      data: options
    });
    if (result.data) {
      this.setData(result);
      this.handlerShowLoading();
    } else {
      this.handlerHideOver();
      this.handlerHideLoading();
      this.setData([]);
      return;
    }
    if (this.pageSize > this.totalPage) {
      this.handlerHideLoading();
      this.handlerShowOver();
    }
  }

  // 添加购物车
  @action
  async addToCart(opts) {
    if (this.isPC()) {
      let result = await ajax({
        type: 'get',
        url: 'https://netcn.console.aliyun.com/core/domainbuy/shopcartadd',
        dataType: 'jsonp',
        data: {
          token: 'check-web-hichina-com:m6tu9sz7e4mv1zhkj1c7iaag2k9rc5ry',
          domainString: opts.domainString,
          periodNum: 12
        }
      });
      switch (result.msg) {
        case 'NOT_LOGINED':
          window.location.href = 'https://account.aliyun.com/login/login.htm?oauth_callback='
            + encodeURIComponent(window.location.href);
          break;
        case 'OK':
          window.location.href = 'https://netcn.console.aliyun.com/core/buy/commonbuy';
          break;
        case 'DOMAINSTRING_OR_PERIODNUM_IS_NULL':
          notification.toast('域名添加失败');
          break;
        case '没有可添加的域名':
          window.location.href = 'https://netcn.console.aliyun.com/core/buy/commonbuy';
          break;
        default:
          notification.toast(result.msg, { type: 'warning' });
          break;
      }
    } else {
      window.location.href = 'https://domain.aliyun.com/contactInfo/contactInfo.htm?year=1'
        + '&domain=' + opts.domainString;
    }
  }

  isPC() {
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
      return false;
    } else {
      return true;
    }
  }

  @action
  setData(result) {
    this.resultList = result.data ? result.data.pageResult.data : [];
    this.totalPage = result.data ? result.data.searchTotal : 0;
    this.listCache = this.resultList;
  }

  @action
  changeRequestOpts(opts) {
    if (opts) {
      for (let key in opts) {
        this.requestOpts[key] = opts[key];
      }
    }
    return this.requestOpts;
  }

  @action
  handlerChangePageSize(pageSize) {
    this.pageSize = pageSize;
  }

  @action
  handlerHideLoading() {
    this.isLoading = false;
  }
  @action
  handlerShowLoading() {
    this.isLoading = true;
  }
  @action
  handlerHideOver() {
    this.isOver = false;
  }
  @action
  handlerShowOver() {
    this.isOver = true;
  }
  @action
  changePageSize() {
    this.pageSize = this.pageSize + this.pageSizeCache;
  }
}

export default new ResultList();



// WEBPACK FOOTER //
// ./src/store/resultListStore.js